export const PAY_METHODS_CR = {
    151: {
        code: 151,
        templete: 'webPayment',
        name: 'Pago desde página web',
        approve: true,
    },
    151.2: {
        code: 151,
        templete: 'cash',
        name: 'Efectivo en corresponsal',
        approve: true,
    },
    280: {
        code: 280,
        templete: 'deposit',
        name: 'Depósito en efectivo',
        approve: false,
    },
    281: {
        code: 281,
        templete: 'transfer',
        name: 'Transferencia',
        approve: false,
    },
    270: {
        code: 270,
        templete: 'deposit',
        name: 'Depósito en efectivo',
        approve: false,
    },
    271: {
        code: 271,
        templete: 'transfer',
        name: 'Transferencia',
        approve: false,
    },
    2500: {
      code: 2500,
      templete: 'transfer',
      name: 'Transferencia',
      approve: false,
  },
};

export const BANK_IDS = {
    BNCR_PAY_WEB: 151,
    BNCR_CASH: 151.2,
    BNCR_DEPOSIT: 280,
    BNCR_TRANSFER: 281,
    BCR_DEPOSIT: 270,
    BCR_TRANSFER: 271,
    LAFISE_TRANSFER: 2500
};

export const COMMERCIAL_NETWORKS_IDS = { PUNTOS_HEY: 1106, AIR_PAK: 201 };

export const ORDER_METHODS = { BNCR: 'bncr', BCR: 'bcr', LAFISE: 'lafise', BNPL: 'bnplbancolombia', CDC: 'cdcbancolombia' };
